import React from 'react'

export default function TermsConditions() {
    return (
        <div>
            <h1>Terms and Conditions for Podurama</h1>

            <h2>Introduction</h2>

            <p>These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, Podurama accessible at https://podurama.com/.</p>

            <p>These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here.
                You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.
                These Terms and Conditions have been generated with the help of the <a href="https://www.termsandcondiitionssample.com">Terms And Conditions Template</a>.
            </p>

            <p>Minors or people below 18 years old are not allowed to use this Website.</p>

            <h2>Intellectual Property Rights</h2>

            <p>Other than the content you own, under these Terms, Podurama and/or its licensors own all the intellectual property rights and materials contained in this Website.</p>

            <p>You are granted limited license only for purposes of viewing the material contained on this Website.</p>

            <h2>Restrictions</h2>

            <p>You are specifically restricted from all of the following:</p>

            <ul>
                <li>publishing any Website material in any other media;</li>
                <li>selling, sublicensing and/or otherwise commercializing any Website material;</li>
                <li>publicly performing and/or showing any Website material;</li>
                <li>using this Website in any way that is or may be damaging to this Website;</li>
                <li>using this Website in any way that impacts user access to this Website;</li>
                <li>using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;</li>
                <li>engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;</li>
                <li>using this Website to engage in any advertising or marketing.</li>
            </ul>

            <p>Certain areas of this Website are restricted from being access by you and Podurama may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.</p>

            <h2>Your Content</h2>

            <p>In these Website Standard Terms and Conditions, &quot;Your Content&quot; shall mean any audio, video text, images or other material you choose to display on this Website. By displaying Your Content, you grant Podurama a non-exclusive, worldwide irrevocable, sub licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.</p>

            <p>Your Content must be your own and must not be invading any third-party’s rights. Podurama reserves the right to remove any of Your Content from this Website at any time without notice.</p>

            <h2>Refund Policy</h2>
            <p>All subscription fees are non-refundable once the trial period has ended. If you cancel during the trial period, you will not be charged. However, after the trial period, no refunds will be issued under any circumstances, including for partial subscription periods.
                Gift cards are always non-refundable under any circumstances.
            </p>

            <h2>Refund Policy On Apple App Store</h2>
            <p>If you request a refund for a purchase made through the Apple App Store, we may be required to share certain consumption data related to your use of the app with Apple to process your request. This data includes, but is not limited to, information about:

                Usage patterns related to the refunded product or service.

                The duration and frequency of usage.

                Consent to Share Data: By initiating a refund request, you explicitly consent to the collection and sharing of relevant consumption data with Apple, solely for the purpose of verifying and processing your refund.

                Privacy: Any data shared with Apple for refund purposes will be handled in compliance with our Privacy Policy and Apple’s data protection requirements.

                No Unauthorized Sharing: We will not share your consumption data with any third parties other than Apple without your explicit consent.
            </p>

            <h2>Cancellation</h2>
            <p>You may cancel your subscription at any time by visiting your account settings in the webapp if purchased through web.
                If purchased through Google Play or the App Store, you can manage and cancel your subscription directly within your Google Play or App Store account settings.
                Your subscription will remain active until the end of the current billing cycle, but no further charges will be applied after cancellation.</p>


            <h2>Your Privacy</h2>

            <p>Please read Privacy Policy.</p>

            <h2>No warranties</h2>

            <p>This Website is provided &quot;as is,&quot; with all faults, and Podurama express no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.</p>

            <h2>Limitation of liability</h2>

            <p>In no event shall Podurama, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract.  Podurama, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.</p>

            <h2>Indemnification</h2>

            <p>You hereby indemnify to the fullest extent Podurama from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.</p>

            <h2>Severability</h2>

            <p>If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.</p>

            <h2>Variation of Terms</h2>

            <p>Podurama is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.</p>

            <h2>Assignment</h2>

            <p>The Podurama is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.</p>

            <h2>Entire Agreement</h2>

            <p>These Terms constitute the entire agreement between Podurama and you in relation to your use of this Website, and supersede all prior agreements and understandings.</p>

            <h2>Governing Law &amp; Jurisdiction</h2>

            <p>These Terms will be governed by and interpreted in accordance with the laws of the State of gb, and you submit to the non-exclusive jurisdiction of the state and federal courts located in gb for the resolution of any disputes.</p>
        </div>
    )
}
